module.exports = __webpack_public_path__ + "img/ae791f4fcb368bc3a3189f726bb25739.700fa0ec.png";